var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZktkNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.26 20.77",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #78bd43;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.91,13.61h-5.9l1.19-4.12h4.21l-.48,1.65h-2.53l-.24.82h4.21s-.48,1.65-.48,1.65ZM42.34,8.67h-5.9l.48-1.65h5.9l-.48,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.87,11.96c-.11.37-.2.64-.29.79-.15.27-.35.48-.61.61-.31.16-.74.25-1.26.25h-2.53c-.54,0-.92-.09-1.14-.27-.18-.14-.26-.36-.23-.65,0-.11.03-.23.06-.36.01-.05.05-.18.11-.37l.71-2.47h1.69l-.72,2.47h2.53l.24-.82h1.68l-.24.82ZM48.59,9.49h-1.68l.24-.82h-4.21c.11-.37.2-.64.29-.79.15-.27.36-.48.62-.61.31-.16.74-.24,1.26-.24h2.53c.54,0,.92.09,1.14.26.18.15.25.36.23.66,0,.11-.03.22-.06.35-.01.05-.05.18-.11.37l-.24.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.36,11.96c-.11.37-.2.64-.29.79-.15.27-.35.48-.61.61-.32.16-.73.25-1.26.25h-2.53c-.54,0-.92-.09-1.14-.27-.17-.14-.25-.36-.23-.65,0-.11.03-.23.06-.35.01-.05.05-.18.11-.38l.72-2.47h1.68l-.72,2.47h2.53l.95-3.29h-4.21c.11-.37.2-.64.29-.79.15-.27.35-.48.61-.61.31-.16.73-.24,1.26-.24h2.53c.54,0,.92.09,1.14.26.18.15.25.36.23.66,0,.11-.03.22-.06.35-.01.05-.05.18-.11.37l-.95,3.29Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.42 1.02 21.74 5.95 25.03 13.58 21.45 13.59 19.22 7.85 16.58 9.91 15.75 13.6 .99 13.61 1.4 11.26 9.99 3.26 3.65 3.26 4.05 1.07 14.32 1.06 13.87 3.1 4.85 11.37 13.45 11.36 15.79 1.06 18.76 1.02 17.44 6.44 24.31 1.03 28.42 1.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.42 1.02 39.49 1.02 38.7 3.26 34.62 3.28 31.53 13.59 28.76 13.59 31.73 3.27 25.36 3.28 28.42 1.02"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.65,16.46l-1.74,3.81h-.9l-.23-2.71-1.22,2.71h-.9s-.36-3.81-.36-3.81h.82l.15,2.96,1.29-2.96h.85l.21,2.94,1.2-2.94h.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.5,16.46l-.11.6h-1.58l-.17,1h1.21l-.1.59h-1.22l-.28,1.62h-.77l.68-3.81h2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.2,16.46l-.67,3.81h-.77l.44-2.47-1.45,2.47h-.58l-.58-2.47-.44,2.47h-.77l.68-3.81h.87l.72,2.83,1.7-2.83h.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZktkNewLogo);
export default __webpack_public_path__ + "static/media/zktk_new_logo.3ef35bae49984c6e93146c48e17462b3.svg";
export { ForwardRef as ReactComponent };